
import type { ReactNode } from 'react';
import { Navigation } from './Navigation';
import { FooterSection } from './FooterSection';
import { MinimalAurora } from './MinimalAurora';

interface LegalPageLayoutProps {
  title: string;
  lastUpdated: string;
  children: ReactNode;
}

export function LegalPageLayout({ title, lastUpdated, children }: LegalPageLayoutProps) {
  return (
    <div className="min-h-screen relative bg-black">
      <MinimalAurora />

      <div className="relative z-10">
        <Navigation />

        <section className="py-24 bg-gradient-to-b from-black to-gray-900">
          <div className="container mx-auto px-6">
            <div className="max-w-3xl mx-auto text-center">
              <h1 className="text-4xl md:text-5xl font-light mb-4 tracking-tight text-white">
                {title}
              </h1>
              <p className="text-gray-500">Last updated: {lastUpdated}</p>
            </div>
          </div>
        </section>

        <section className="py-16">
          <div className="container mx-auto px-6">
            <div className="max-w-3xl mx-auto">{children}</div>
          </div>
        </section>

        <FooterSection />
      </div>
    </div>
  );
}

export function LegalSection({ title, children }: { title: string; children: ReactNode }) {
  return (
    <section className="mb-12">
      <h2 className="text-2xl font-medium text-white mb-4">{title}</h2>
      <div className="space-y-4 text-gray-400 leading-relaxed">{children}</div>
    </section>
  );
}
